.me-dropdown__menu:has(dropdown-menu-type-2) {
  padding: 0;

  @include desktop-lg {
    position: absolute;
    top: 100%;
    padding: 0;
    margin: 0;
    border: none;
    transform: none;
    background: inherit;
  }
}

.dropdown-menu-type-2 {
  @include desktop-lg {
    position: relative;
    left: 0;
    right: 0;
    z-index: 1001;
    margin: 0;
    transform: none;
  }

  &__wrapper {
    @include desktop-lg {
      width: 100vw;
      max-width: 100vw;
      background: var(--background-color-primary);
      border-radius: 0;
      border-bottom: var(--border-size-sm) solid var(--border-color-primary);
      border-left: none;
      border-right: none;
      overflow: visible;
      box-shadow: 0 4px 12px rgb(44 44 44 / 12%);
    }
  }

  &__container {
    @include desktop-lg {
      @include container;
    }
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xl); /* ✓ Figma mobile: 24px between navigation and featured */

    @include desktop-lg {
      flex-direction: row;
      padding-top: 0;
      gap: 0;
    }
  }

  &__navigation {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xl); /* ✓ Figma mobile: 24px between navigation groups */

    @include desktop-lg {
      flex-direction: row;
      gap: var(--spacing-2xl); /* ✓ Figma: 32px */
      flex: 1 1 0;
      min-width: 0;
      padding: var(--spacing-2xl) var(--spacing-2xl) var(--spacing-2xl) 0; /* ✓ Figma: py-32px pr-32px */
    }

    .dropdown-menu-type-2__navigation-item {
      &:nth-child(n + 3) {
        @include desktop-lg {
          margin-left: calc(map-get($map: $spacings, $key: md) / -1);
        }

        @include above($breakpoint-desktop-md) {
          margin-left: calc(map-get($map: $spacings, $key: 2xl) / -1);
        }

        @include above($media-desktop) {
          margin-left: calc(map-get($map: $spacings, $key: 6xl) / -1);
        }
      }
    }
  }

  &__navigation-item {
    @include desktop-lg {
      flex: 1 1 0;
      min-width: 0;
    }

    [slot='navigation-group'] {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-xs); /* ✓ Figma mobile: 8px between menu items */

      > me-button {
        .me-button {
          padding: var(--spacing-xs) 0; /* ✓ Figma mobile: py-8px, h-40px */
        }
      }

      @include desktop-lg {
        display: block;
        gap: 0;

        > me-button {
          .me-button {
            padding: initial;
          }
        }
      }
    }

    .me-heading {
      font-size: map-get($font-sizes, sm); /* ✓ Figma: 14px */
      font-weight: map-get($font-weights, semi-bold); /* ✓ Figma: 600 */
      margin-bottom: 0;

      @include desktop-lg {
        margin-bottom: var(--spacing-md); /* ✓ Figma: 16px gap between title and items */
      }
    }
  }

  &__element-item {
    &:not(:last-child) {
      margin-bottom: var(--spacing-md); /* ✓ Figma: 16px gap between items */
    }

    .me-button {
      white-space: normal;

      .me-icon.me-button__icon {
        height: 24px;
        width: 24px;
      }
    }
  }

  &__description {
    margin-left: calc(var(--spacing-2xl) + var(--spacing-2xs));
    font-size: map-get($font-sizes, sm);
    color: var(--color-neutral-neutral-dark);
    line-height: map-get($line-heights, lg);
  }

  &__featured {
    position: relative;
    background: var(--background-color-secondary);
    padding: var(--spacing-xl); /* ✓ Figma mobile: 24px */

    @include desktop-lg {
      flex: 0 0 auto;
      width: 560px; /* ✓ Figma: 560px */
      padding: var(--spacing-2xl) 0 var(--spacing-2xl) var(--spacing-2xl); /* ✓ Figma: py-32px pl-32px */
      display: flex;
      flex-direction: column;
      gap: var(--spacing-md); /* ✓ Figma: 16px */
    }

    &::before {
      content: '';
      position: absolute;
      top: 0;
      left: 100%;
      width: 9999px;
      height: 100%;
      background: var(--background-color-secondary);
    }

    .me-heading {
      margin-bottom: 0; /* gap handles spacing */
      font-size: map-get($font-sizes, sm); /* ✓ Figma: 14px */
      font-weight: map-get($font-weights, semi-bold); /* ✓ Figma: 600 */
    }
  }

  &__featured-cards {
    display: flex;
    flex-direction: column;
    gap: var(--spacing-xs); /* ✓ Figma: 8px between blog items */
    white-space: normal;
    margin-bottom: 0;
  }

  &__featured-card {
    padding: var(--spacing-xs) 0; /* ✓ Figma: py-8px */

    .featured-card__content {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-sm);
      align-items: flex-start;

      @include desktop-lg {
        flex-direction: row;
        gap: var(--spacing-xl); /* ✓ Figma: 24px between image and content */
      }
    }

    .featured-card__image {
      max-width: 100%;
      overflow: hidden;

      @include desktop-lg {
        flex: 0 0 160px; /* ✓ Figma: 160px */
        max-width: 160px;
        height: 105px; /* ✓ Figma: 105px */
      }
    }

    .featured-card__text {
      display: flex;
      flex-direction: column;
      gap: var(--spacing-xs); /* ✓ Figma: 8px between content blocks */
      flex: 1;
      min-width: 0;
    }

    .featured-card__title {
      font-size: map-get($font-sizes, md); /* ✓ Figma: 16px */
      font-weight: map-get($font-weights, semi-bold); /* ✓ Figma: 600 */
      color: var(--color-neutral-neutral-dark);
    }

    .featured-card__description {
      margin-top: calc(var(--spacing-2xs) - var(--spacing-xs)); /* ✓ Figma: 4px gap (8px from parent gap - 4px = net 4px) */
      font-size: map-get($font-sizes, sm); /* ✓ Figma: 14px */
      line-height: map-get($line-heights, lg);
      color: var(--color-neutral-neutral);
    }

    .featured-card__action {
      font-size: map-get($font-sizes, sm); /* ✓ Figma: 14px */
      color: var(--link-color-brand-primary);
      font-weight: map-get($font-weights, regular);
      text-decoration: underline; /* ✓ Figma: underline */

      &:hover {
        color: var(--color-brand-primary-dark);
      }
    }
  }

  @include below($breakpoint-desktop) {
    &__featured-card {
      .featured-card__image {
        max-width: 100%;
      }
    }
  }

  &__featured:not(:has(*)) {
    display: none;
  }
}

.me-dropdown {
  .dropdown-menu-type-2 {
    .me-button {
      white-space: normal;
    }
  }
}
